import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import DefaultDialog from '../../components/DefaultDialog';
import Loading from '../../components/Loading';
import flows from './flows';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function SalesFlow(props) {
  const {
    onClose,
    show,
    flowType,
    saleType
  } = props;
  const [loadingMessage, setLoadingMessage] = useState(null);
  const username = useSelector(state => state.auth.profile.name || state.auth.profile.username);
  const [saleData, setSaleData] = useState({
    customerName: null,
    salesperson: username,
    createdBy: username,
    isNewCustomer: true,
    productTypes: {
      recovr: false,
      recovrKeys: false
    },
    warrantyLength: null,
    keysWarranty: null
  });
  const onChange = useCallback(event => {
    if (Array.isArray(event)) {
      const arrayData = event.reduce((acc, curr) => {
        const {
          data,
          value
        } = curr;
        return {
          ...acc,
          [data]: value
        };
      }, {
        ...saleData
      });
      return setSaleData(arrayData);
    }
    const {
      data,
      value
    } = event;
    return setSaleData({
      ...saleData,
      [data]: value
    });
  }, [saleData]);
  const useFlow = flows[flowType || saleType];
  const {
    title,
    icon,
    currentStep
  } = useFlow({
    ...props,
    setLoadingMessage,
    saleData,
    onChange
  });
  const {
    contentClass,
    content,
    ...dialogProps
  } = currentStep;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DefaultDialog, {
      contentClassName: contentClass,
      show: show && !loadingMessage,
      title: title,
      titleIcon: icon || 'https://recovr-ui-assets.storage.googleapis.com/sales-flow-header.svg',
      onClose: onClose,
      ...dialogProps,
      children: content && content()
    }), /*#__PURE__*/_jsx(Loading, {
      message: loadingMessage,
      loading: !!loadingMessage
    })]
  });
}
export default SalesFlow;